export default "__VITE_ASSET__BM$1040W__"